import React from 'react'
import SarasTrans from '../../../library/notifications/SarasTrans';

//starting with capital letter will ensure this is treated as a component
const QCGridItemD = ({formObject, viewData, rowKey}) => {

    return (
        <div className="saras-cell">
            <ul className="uiListTable">
                {Object.values(viewData.childRows).map((row,index)=>(
                    <li className="uiListRow">
                        <ul>
                            <li>
                                <span className="uiBold uiColumn350">{row.rowValues.itemName.valF}</span>
                            </li>
                            <li>
                                <ul>
                                    <li className="uiColumnCenter uiColumn30">
                                    </li>
                                    <li className="uiColumnCenter uiColumn50">
                                        <SarasTrans value="Tot" />
                                    </li>
                                    <li className="uiColumnCenter uiColumn50">
                                        <SarasTrans value="QC" />
                                    </li>
                                    <li className="uiColumnCenter uiColumn50">
                                        <SarasTrans value="P" />
                                    </li>
                                    <li className="uiColumnCenter uiColumn50">
                                        <SarasTrans value="F" />
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <ul>
                                    <li className="uiColumnCenter uiColumn30">
                                        <SarasTrans value="Qty" />
                                    </li>
                                    <li className="uiColumnCenter uiColumn50">
                                        <span className="sItemID">{row.rowValues.total.valF}</span>
                                    </li>
                                    <li className="uiColumnCenter uiColumn50">
                                        <span className="sItemID">{row.rowValues.sampled.valF}</span>
                                    </li>
                                    <li className="uiColumnCenter uiColumn50">
                                        <span className="sItemID">{row.rowValues.pass.valF}</span>
                                    </li>
                                    <li className="uiColumnCenter uiColumn50">
                                        <span className="sItemID">{row.rowValues.failed.valF}</span>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                ))
                }
            </ul>
        </div>
    );
}

export default QCGridItemD
